
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemDetailDialog extends Serenity.EntityDialog<Adv05ItemDetailRow, any> {
        protected getFormKey() { return Adv05ItemDetailForm.formKey; }
        protected getIdProperty() { return Adv05ItemDetailRow.idProperty; }
        protected getLocalTextPrefix() { return Adv05ItemDetailRow.localTextPrefix; }
        protected getNameProperty() { return Adv05ItemDetailRow.nameProperty; }
        protected getService() { return Adv05ItemDetailService.baseUrl; }
        protected getDeletePermission() { return Adv05ItemDetailRow.deletePermission; }
        protected getInsertPermission() { return Adv05ItemDetailRow.insertPermission; }
        protected getUpdatePermission() { return Adv05ItemDetailRow.updatePermission; }

        protected form = new Adv05ItemDetailForm(this.idPrefix);

    }
}